module.exports = "<h3 id=\"credits\">\n  <a ui-sref=\"app.users.bundle\">\n    <i ng-class=\"animate? 'animated flip' : ''\" class=\"fa fa-cogs\"></i>\n    {{creditNum}} {{creditNum === 1 ? 'Credit' : 'Credits'}}\n  </a>\n</h3>";


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/credits/template.html
// module id = 1961
// module chunks = 0